import {RWSService} from '@rws-framework/client';
import { learnosityTextRender } from '../helpers/learnosityTextRender';

class LearnosityDRService extends RWSService {
  static _IN_CLIENT: boolean = true;

  //html for distractor rationale
  private createTemplate(type: string, text: string) {
    if (!text) return;
    if (Array.isArray(text)) text = text?.[0] || "" // because Derek has uploaded 1000s of questions like that over the years...
    const updatedText = learnosityTextRender(text);
    if (type === 'grey') {
      return `
        <div class="distractor grey">${updatedText}</div>`;
    } else {
      return `
      <div class="distractor ${type}">
        <span class="material-symbols-outlined icon">${ type === 'red' ? 'close' : 'check'}</span>
        <span>${updatedText}</span>
      </div>`;
    }
  }

  public distractorRationale(question, responseID: string, iframeWindow) {
    //generic distractor rationale (DR)
    const dr = question.getMetadata().distractor_rationale || '';

    //response level
    const level = question.getMetadata().distractor_rationale_response_level;

    const score = question.getScore();

    // Using response level distractor rationale if available and match against all that are not unattempted (that's in options too)
    const options = question.mapValidationMetadata('distractor_rationale_response_level');

    //do not show grey DR when the answer is fully correct and flag is off on reseller
    const not_show_grey = score && score.score === score.max_score && !options?.incorrect?.length && !window.labelBundle.distractor_rationale;

    // if we have dr, and we got to this point, we include the dr
    // Generic DR is red when flag is turned off
    const dr_color = window.labelBundle.distractor_rationale ? 'grey' : 'red';
    let outputHTML = dr && !not_show_grey ? this.createTemplate(dr_color, dr) : '';

    if (options) {
      const correctIndexes = new Set(options.correct.map(opt => opt.index));
      const incorrectIndexes = new Set(options.incorrect.map(opt => opt.index));
      
      const all_options = [...options.correct, ...options.incorrect].sort((a, b) => a.index - b.index);
      
      for (const option of all_options) {
        //reseller flag to show DR on correct responses
        if (window.labelBundle.distractor_rationale) { 
          if (correctIndexes.has(option.index) && option.metadata) {
            outputHTML += this.createTemplate('green', option.metadata);
          } // type is necessarily exactMatch here so incorrect would be empty
        
        }
        if (incorrectIndexes.has(option.index) && option.metadata) {
          outputHTML += this.createTemplate('red', option.metadata);
        }
      }
    }
    if (outputHTML) {
      outputHTML = '<div id="' + responseID + '_distractor" class="distractor_style">' + outputHTML + '</div>';
    }

    const element = $(iframeWindow.document).find("#" + responseID + "_distractor");
    if (element && element.length) {
      $(iframeWindow.document).find("#" + responseID + "_distractor").html(outputHTML).removeClass().addClass('distractor_style').fadeIn();
    } else {
      $(iframeWindow.document).find("#" + responseID).append(outputHTML);
    }
    if (iframeWindow.MathJax) {
        iframeWindow.MathJax.typeset($(iframeWindow.document).find("#" + responseID))
    }
  }
}

export default LearnosityDRService.getSingleton();

export {LearnosityDRService as LearnosityDRServiceInstance};
